import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/store';
import { FC, useState } from 'react';
import {
  getAvailableAttributionCompareModels,
  selectIsAttributionComparisonActive,
  getSelectedAttributionCompareModel,
  selectAttributionCompareModel,
  setDisplayAttributionComparisonData
} from './availableAttributionCompareModelsSlice';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import Button from 'common/components/buttons/button';
import DropdownMenu from 'common/components/drop-downs/drop-down-menu';
import DropdownMenuButton from 'common/components/drop-downs/dropdown-menu-button';

const AttributionCompareButton: FC = () => {
  const dispatch = useDispatch();

  const { isPocModeActive } = useSelector(
    (state: RootState) => state.pocToggle
  );

  const attributeModelRoutes = useSelector((state: RootState) =>
    getAvailableAttributionCompareModels(state, isPocModeActive)
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const displayDropDown = useSelector((state: RootState) =>
    selectIsAttributionComparisonActive(state)
  );

  const selectedAttributionModel = useSelector((state: RootState) =>
    getSelectedAttributionCompareModel(state, isPocModeActive)
  );

  return (
    <div className="md:ml-3">
      {displayDropDown ? (
        <div className="flex">
          <DropdownMenu
            isDropdownOpen={isDropdownOpen}
            containerClasses="flex justify-center relative w-60 mr-3"
            buttonClasses="flex text-sm items-center py-2.5 px-3 justify-center bg-white rounded border border-neutral-200 w-60  flex-row-reverse px-3 py-2 bg-white"
            buttonIconClasses="ra-icons-generic-down-arrow text-bottom text-xs flex"
            buttonLabel={selectedAttributionModel.modelName}
            buttonLabelClasses="text-sm mr-2 capitalize"
            dropdownMenuClasses="z-40 top-11 left-0 w-60"
            onDropdownClicked={() => setIsDropdownOpen(!isDropdownOpen)}
            onClickAway={() => setIsDropdownOpen(false)}
          >
            {attributeModelRoutes.map((model) => (
              <DropdownMenuButton
                key={`custom-data-key-${model.id}`}
                identifier={`custom-data-key-${model.id}`}
                buttonClasses="flex items-center"
                onClick={() => {
                  dispatch(selectAttributionCompareModel(model.id));
                  setIsDropdownOpen(false);
                }}
              >
                <span className="capitalize text-sm">{model.modelName}</span>
              </DropdownMenuButton>
            ))}
          </DropdownMenu>
          <div>
            <Button
              identifier="clear-btn"
              theme={ButtonTheme.CANCEL}
              onClick={() =>
                dispatch(setDisplayAttributionComparisonData(false))
              }
            >
              <i className="ra-icons-generic-cross text-xl flex"></i>
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <Button
            identifier="compare-btn"
            theme={ButtonTheme.CANCEL}
            onClick={() => dispatch(setDisplayAttributionComparisonData(true))}
          >
            <div className="flex">
              <i className="ra-icons-generic-sort-3 rotate-90 text-xl mr-2 flex"></i>
              Compare
            </div>
          </Button>
        </div>
      )}
    </div>
  );
};

export default AttributionCompareButton;
